import React, { Component } from 'react';
import { lang } from 'lang';
import { ScrollView, Button, TextInput, Scene, AppHeader, View, Text } from 'core';
import { css, theme } from 'constants';
import * as actions from 'actions';

const styles = css({
    container: {
        flex: 1,
        padding: 20,
        alignItems: 'center'
    },
    label: {
        minWidth: 300,
        marginVertical: 5,
        color: theme.gray_color_lighten(0.7)
    },
    tips: {
        marginVertical: 5,
        color: theme.gray_color_lighten(0.5),
        width: 400
    },
    input: {
        textAlign: 'center',
        marginBottom: 20
    },
    btn: {
        alignSelf: 'center'
    }
});

class Username extends Component {
    constructor(props) {
        super(props);
        this.state = { name: props.user.name || '' };
    }
    render() {
        const { name } = this.state;
        const { status } = this.props;
        return (
            <Scene>
                <AppHeader title={lang.CHANGE_NAME} close />
                <ScrollView style={{ flex: 1 }} contentContainerStyle={styles.container}>
                    <Text style={styles.label}>{lang.FULL_NAME}</Text>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <TextInput onChangeText={name => this.setState({ name })} value={name} style={styles.input} autoCorrect={false} autoFocus />
                    </View>
                    <Button
                        style={styles.btn}
                        title={lang.SAVE}
                        disabled={status.is_loading || name.trim() === ''}
                        onPress={() => actions.sendChangeName({ name })}
                        status={status}
                        onSuccess={() => {
                            actions.clickCloseModal();
                        }}
                    />
                </ScrollView>
            </Scene>
        );
    }
}

/*
<View style={{ backgroundColor: theme.gray_color_lighten(0.08), borderRadius: 5, padding: 10, marginBottom: 20 }}>
            <Text style={[styles.tips, { marginBottom: 5 }]}>
              {`Fosol is a community where everyone uses the name they go by in everyday life. This makes it so that you always know who you're connecting with.`}
            </Text>
            <Text style={[styles.tips]}>{'Fosol only allows you to change your name once per month'}</Text>
          </View>
*/
export default Username;



// WEBPACK FOOTER //
// ./src/components/modals/change_name.js